<template>
  <v-app-bar app color="primary" dark height="95" class="back-color" >
    <div class="d-flex align-center" style="margin-left: -10px; ">
      <v-img 
        alt="School Logo"
        class="shrink mr-2 img-align"
        contain
        :src="org.logo"
        transition="scale-transition"
       
      />
    </div>

    <v-spacer></v-spacer>

    <v-btn href="https://edupluscampus.com/" target="_blank" text>
      <span class="mr-2 ">EasyPariksha</span>
      <v-icon>mdi-open-in-new</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import axios from 'axios'
export default {
  data(){
    return{
      org:{
        logo:"",
        redirection:null,
      }
    }
  },
  mounted(){
    axios.post("/login/login",{
      dns: window.location.hostname
    })
    .then(res => {
        if(res.data.msg=="200"){
          this.org.logo = res.data.logo
          localStorage.setItem("EPS-org-logo",res.data.logo)
          // localStorage.setItem("redirection", "0");
          this.redirection = localStorage.getItem("redirection");
          if(this.redirection == "1"){
            // console.log("inside if where redirection is 1")
            this.$router.push("/forgot-password")
          } else{
            // console.log("inside else where redirection is 0")
                if(res.data.user == "SuperAdmin"){
              this.$router.push("/eps-admin");
            }else{
              this.$router.push('/').catch(err => {})
              // this.$router.push("/");
            }
          }
          
        }
        else{
          localStorage.setItem("EPS-org-logo",'')
          this.org.logo = "https://edupluscampus.com/img/logos/1.png"
        }
      })
    .catch()
  }
}
</script>
<style scoped>
.back-color{
/*background: linear-gradient(90deg, hsla(217, 100%, 50%, 1) 0%, hsla(186, 100%, 69%, 1) 130%);*/
    background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);

}
.mr-2{
  font-weight: bold;
  font-size: 20px;
}
.img-align{
width: 190px; 
height: 114px; 
margin:3px
}
.mr-2  {
    text-transform: none;
}
.sidebar-link {
  text-decoration: none;
}
.sidebar-link-item:hover {
  background-color: rgb(181, 186, 190) !important;
}
@media print {
  .print-push-left {
    margin-left: -256px;
    display: none !important;
  }
}
.instagram {
  text-transform: uppercase;
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>